import(/* webpackChunkName: "imageTextTeaserHorizontal" */ '../../Styles/ImageTextTeaserHorizontal/imageTextTeaserHorizontal.scss');
import "jquery-match-height";

window.am = window.am || {};

window.am.imageTextTeaserHorizontal = new function () {
    var that = this;
    var lotteryPage = document.querySelector('.lottery-page');

    that.setHeightOfContainer = function () {
        $(".imageTextTeaserHorizontal.js-equalHeight").matchHeight();
        var imageTextTeaserHorizontal = $('.imageTextTeaserHorizontal');

        if (imageTextTeaserHorizontal.length < 1) {
            return;
        }

        imageTextTeaserHorizontal.each(function () {
            let imageCaption = $(this).find('.image-caption');

            if (imageCaption.length < 1) {
                return;
            }

            let image = $(this).find('img');
            let text = $(this).find('.imageTextTeaserHorizontal__col--text');

            $(text[0]).css({ marginBottom: 'auto' });
            $(imageCaption[0]).css({ top: 'auto' });
            $(image[0]).css({ paddingBottom: 'auto' });
            $(text[0]).css({ height: 'auto' });

            if (window.innerWidth >= 768) {

                $(text[0]).css({ marginBottom: imageCaption[0].offsetHeight });
                $(image[0]).css({ paddingBottom: imageCaption[0].offsetHeight });
                $(imageCaption[0]).css({ top: text[0].offsetHeight });
            } else {
                if (!lotteryPage) {
                    $(image[0]).css({ height: '100%' });
                }
                
                $(text[0]).css({ height: '100%' });
            }
        });
    }

    that.init = function () {
        
        var $imageTextTeaserHorizontalComponents = $(".imageTextTeaserHorizontal");
        var lotteryPage = document.querySelector('.lottery-page');
        if (lotteryPage) {
            if ($imageTextTeaserHorizontalComponents.length > 0) {
                window.addEventListener("load", that.setHeightOfContainer);
                };
        }
        else {
            $(".imageTextTeaserHorizontal").find('img.lazyload').on('load', function () {
                $(".imageTextTeaserHorizontal.js-equalHeight").matchHeight();
                that.setHeightOfContainer();
            });
        }            

        window.addEventListener("resize", that.setHeightOfContainer);
        window.addEventListener("orientationchange", that.setHeightOfContainer);
    };
};

window.am.imageTextTeaserHorizontal.init();